import { BlockedTank } from 'src/types/ViewModel/Stowage/BlockedTank';

export const createBlockedTankChangeData = (blockedTank: BlockedTank): Partial<BlockedTank> => {
    return {
        tankId: blockedTank.tankId,
        fromPortCallGuid: blockedTank.fromPortCallGuid,
        fromBerthCallGuid: blockedTank.fromBerthCallGuid,
        toPortCallGuid: blockedTank.toPortCallGuid,
        toBerthCallGuid: blockedTank.toBerthCallGuid,
    };
};
